// Constants untuk form debtor
export const DEBTOR_TYPES = [
  { value: 'individual', label: 'Perorangan' },
  { value: 'corporate', label: 'Badan Usaha' },
];

export const ID_TYPES = [
  { value: 'ktp', label: 'KTP' },
  { value: 'passport', label: 'Paspor' },
  { value: 'npwp', label: 'NPWP' },
  { value: 'siup', label: 'SIUP' },
];

export const GENDER_OPTIONS = [
  { value: 'male', label: 'Laki-laki' },
  { value: 'female', label: 'Perempuan' },
];

export const MARITAL_STATUS_OPTIONS = [
  { value: 'single', label: 'Belum Menikah' },
  { value: 'married', label: 'Menikah' },
  { value: 'divorced', label: 'Cerai' },
  { value: 'widowed', label: 'Janda/Duda' },
];

export const STATUS_OPTIONS = [
  { value: 'active', label: 'Aktif' },
  { value: 'inactive', label: 'Tidak Aktif' },
  { value: 'blocked', label: 'Diblokir' },
];

export const CREDIT_QUALITY_OPTIONS = [
  { value: 'lancar', label: 'Lancar' },
  { value: 'dpl', label: 'Dalam Perhatian Khusus' },
  { value: 'kurang_lancar', label: 'Kurang Lancar' },
  { value: 'diragukan', label: 'Diragukan' },
  { value: 'macet', label: 'Macet' },
];

export const SLIK_QUALITY_OPTIONS = [
  { value: '1', label: 'Kolektibilitas 1 - Lancar' },
  { value: '2', label: 'Kolektibilitas 2 - DPK' },
  { value: '3', label: 'Kolektibilitas 3 - Kurang Lancar' },
  { value: '4', label: 'Kolektibilitas 4 - Diragukan' },
  { value: '5', label: 'Kolektibilitas 5 - Macet' },
];

export const SLIK_STATUS_OPTIONS = [
  { value: 'clean', label: 'Bersih' },
  { value: 'watchlist', label: 'Waspada' },
  { value: 'blacklist', label: 'Blacklist' },
];

export const RELATION_TYPES = [
  { value: 'individual', label: 'Perorangan' },
  { value: 'corporate', label: 'Badan Usaha' },
];
